import { useState, useEffect, useRef } from "react";

const FontLink = () => {
  useEffect(() => {
    const l = document.createElement("link");
    l.rel = "stylesheet";
    l.href = "https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Outfit:wght@300;400;500;600;700&display=swap";
    document.head.appendChild(l);
  }, []);
  return null;
};

/* ─────────────────────────────────────────
   ALL SVG ICONS — zero emojis anywhere
───────────────────────────────────────── */
const IC = {
  Code:    () => <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/></svg>,
  Health:  () => <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>,
  Grid:    () => <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>,
  Brain:   () => <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96-.46 2.5 2.5 0 0 1-2.96-3.08 3 3 0 0 1-.34-5.58 2.5 2.5 0 0 1 1.32-4.24 2.5 2.5 0 0 1 1.98-3z"/><path d="M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 0 4.96-.46 2.5 2.5 0 0 0 2.96-3.08 3 3 0 0 0 .34-5.58 2.5 2.5 0 0 0-1.32-4.24 2.5 2.5 0 0 0-1.98-3z"/></svg>,
  Chart:   () => <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/><line x1="2" y1="20" x2="22" y2="20"/></svg>,
  Globe:   () => <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>,
  Pulse:   () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>,
  CPU:     () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="4" width="16" height="16" rx="2"/><rect x="9" y="9" width="6" height="6"/><line x1="9" y1="1" x2="9" y2="4"/><line x1="15" y1="1" x2="15" y2="4"/><line x1="9" y1="20" x2="9" y2="23"/><line x1="15" y1="20" x2="15" y2="23"/><line x1="20" y1="9" x2="23" y2="9"/><line x1="20" y1="14" x2="23" y2="14"/><line x1="1" y1="9" x2="4" y2="9"/><line x1="1" y1="14" x2="4" y2="14"/></svg>,
  Shield:  () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>,
  Eye:     () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"/><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/></svg>,
  Zap:     () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>,
  Monitor: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>,
  Award:   () => <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="6"/><path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11"/></svg>,
  Layers:  () => <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/></svg>,
  Sparkle: () => <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3l1.5 4.5L18 9l-4.5 1.5L12 15l-1.5-4.5L6 9l4.5-1.5z"/><path d="M5 3l.75 2.25L8 6l-2.25.75L5 9l-.75-2.25L2 6l2.25-.75z"/><path d="M19 15l.75 2.25L22 18l-2.25.75L19 21l-.75-2.25L16 18l2.25-.75z"/></svg>,
  Infinite:() => <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"><path d="M12 12c-2-2.5-4-4-6-4a4 4 0 0 0 0 8c2 0 4-1.5 6-4z"/><path d="M12 12c2 2.5 4 4 6 4a4 4 0 0 0 0-8c-2 0-4 1.5-6 4z"/></svg>,
  Users:   () => <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
  IVF:     () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"/><path d="M12 2v3m0 14v3M2 12h3m14 0h3m-3.07-7.07-2.12 2.12M7.17 16.83l-2.12 2.12M19.07 19.07l-2.12-2.12M7.17 7.17 5.05 5.05"/></svg>,
  HMS:     () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>,
  HR:      () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87m-4-12a4 4 0 0 1 0 7.75"/></svg>,
  ERP:     () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8m-4-4v4"/><path d="M7 8h10M7 12h6"/></svg>,
  Web:     () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>,
  CRM:     () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>,
  AI:      () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="2"/><path d="M12 2v3m0 14v3M2 12h3m14 0h3m-3.64-6.36-2.12 2.12M7.76 16.24l-2.12 2.12M20.36 20.36l-2.12-2.12M7.76 7.76 5.64 5.64"/><circle cx="12" cy="12" r="6" strokeDasharray="2 3"/></svg>,
  Arrow:   () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="7" y1="17" x2="17" y2="7"/><polyline points="7 7 17 7 17 17"/></svg>,
  Mail:    () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>,
  Phone:   () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.4 2 2 0 0 1 3.59 1.23h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.73a16 16 0 0 0 6.29 6.29l.87-.87a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21.73 16.92z"/></svg>,
  MapPin:  () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>,
  LinkedIn:() => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/><rect x="2" y="9" width="4" height="12"/><circle cx="4" cy="4" r="2"/></svg>,
  Twitter: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4l16 16M4 20L20 4"/></svg>,
  Github:  () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"/></svg>,
  Check:   () => <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>,
  Quote:   () => <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor"><path d="M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1 0 1 1 1z"/><path d="M15 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2h.75c0 2.25.25 4-2.75 4v3c0 1 0 1 1 1z"/></svg>,
};

/* ─────────────────────────────────────────
   CSS
───────────────────────────────────────── */
const CSS = `
  *,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
  :root{
    --ink:#03040a;--deep:#06091a;
    --card:rgba(255,255,255,0.03);--rim:rgba(255,255,255,0.07);
    --c:#00e5ff;--v:#a259ff;--g:#00ffb2;--fire:#ff6b35;
    --txt:#d6daf0;--muted:#636882;--white:#ffffff;
    --D:'Bebas Neue',sans-serif;--B:'Outfit',sans-serif;
  }
  html{scroll-behavior:smooth}
  body{background:var(--ink);color:var(--txt);font-family:var(--B);overflow-x:hidden}
  ::selection{background:var(--c);color:#000}
  ::-webkit-scrollbar{width:3px}::-webkit-scrollbar-track{background:transparent}::-webkit-scrollbar-thumb{background:var(--v);border-radius:3px}
  body::after{content:'';position:fixed;inset:0;pointer-events:none;z-index:0;opacity:.45;background:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.04'/%3E%3C/svg%3E")}

  .cur-dot{position:fixed;top:0;left:0;width:8px;height:8px;background:var(--c);border-radius:50%;pointer-events:none;z-index:9999;transform:translate(-50%,-50%);transition:width .2s,height .2s,background .2s;mix-blend-mode:difference}
  .cur-ring{position:fixed;top:0;left:0;width:36px;height:36px;border:1px solid rgba(0,229,255,.5);border-radius:50%;pointer-events:none;z-index:9998;transform:translate(-50%,-50%);transition:all .12s ease}
  body:has(a:hover) .cur-dot,body:has(button:hover) .cur-dot{width:16px;height:16px;background:var(--v)}
  body:has(a:hover) .cur-ring,body:has(button:hover) .cur-ring{width:56px;height:56px;border-color:rgba(162,89,255,.6)}

  .nav{position:fixed;top:0;inset-inline:0;z-index:200;display:flex;align-items:center;justify-content:space-between;padding:0 4%;height:68px;transition:background .4s,border-color .4s}
  .nav.glass{background:rgba(3,4,10,.85);backdrop-filter:blur(24px) saturate(1.6);border-bottom:1px solid var(--rim)}
  .logo{font-family:var(--D);font-size:2rem;letter-spacing:.08em;text-decoration:none;background:linear-gradient(120deg,#fff 40%,var(--c));-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text}
  .nav-links{display:flex;gap:2.5rem;list-style:none}
  .nav-links a{color:var(--muted);font-size:.82rem;font-weight:500;text-decoration:none;letter-spacing:.06em;text-transform:uppercase;transition:color .2s;position:relative}
  .nav-links a::after{content:'';position:absolute;bottom:-3px;left:0;right:0;height:1px;background:var(--c);transform:scaleX(0);transition:transform .3s}
  .nav-links a:hover{color:var(--white)}.nav-links a:hover::after{transform:scaleX(1)}
  .nav-btn{padding:.5rem 1.4rem;border-radius:6px;border:1px solid rgba(0,229,255,.3);background:rgba(0,229,255,.06);color:var(--c);font-size:.8rem;font-weight:600;letter-spacing:.06em;text-transform:uppercase;cursor:pointer;font-family:var(--B);transition:all .3s}
  .nav-btn:hover{background:rgba(0,229,255,.15);box-shadow:0 0 20px rgba(0,229,255,.2)}

  .hero{min-height:100vh;display:flex;flex-direction:column;justify-content:center;align-items:center;text-align:center;padding:130px 4% 80px;position:relative;overflow:hidden}
  .hero-mesh{position:absolute;inset:0;z-index:0;background:radial-gradient(ellipse 100% 70% at 50% -5%,rgba(0,229,255,.13) 0%,transparent 60%),radial-gradient(ellipse 50% 60% at 90% 80%,rgba(162,89,255,.1) 0%,transparent 55%),radial-gradient(ellipse 40% 50% at 5% 60%,rgba(0,255,178,.07) 0%,transparent 50%)}
  .hero-canvas{position:absolute;inset:0;z-index:1}
  .hero-z{position:relative;z-index:3;max-width:1000px}
  .eyebrow{display:inline-flex;align-items:center;gap:10px;padding:7px 18px;border-radius:100px;border:1px solid rgba(0,229,255,.25);background:rgba(0,229,255,.06);font-size:.72rem;font-weight:600;letter-spacing:.12em;text-transform:uppercase;color:var(--c);margin-bottom:2.2rem;animation:fadeUp .9s ease both}
  .blink{width:6px;height:6px;border-radius:50%;background:var(--c);animation:blink 1.4s infinite}
  @keyframes blink{0%,100%{opacity:1}50%{opacity:.2}}
  .hero-h1{font-family:var(--D);font-size:clamp(4.5rem,12vw,10rem);line-height:.9;letter-spacing:.03em;color:var(--white);margin-bottom:1.5rem;animation:fadeUp .9s .12s ease both}
  .hero-h1 .accent{background:linear-gradient(120deg,var(--c),var(--v),var(--g));-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;display:inline-block;filter:drop-shadow(0 0 40px rgba(0,229,255,.3))}
  .hero-p{font-size:clamp(.95rem,2vw,1.15rem);font-weight:300;color:var(--muted);max-width:580px;margin:0 auto 2.5rem;line-height:1.8;animation:fadeUp .9s .22s ease both}
  .hero-btns{display:flex;gap:1rem;justify-content:center;flex-wrap:wrap;animation:fadeUp .9s .32s ease both}
  .btn-c{padding:.9rem 2.2rem;border-radius:8px;background:linear-gradient(135deg,var(--c),#0080ff);border:none;color:#000;font-weight:700;font-size:.88rem;letter-spacing:.04em;font-family:var(--B);cursor:pointer;position:relative;overflow:hidden;transition:transform .3s,box-shadow .3s}
  .btn-c::before{content:'';position:absolute;inset:0;background:linear-gradient(120deg,transparent 30%,rgba(255,255,255,.3) 50%,transparent 70%);transform:translateX(-100%);transition:transform .5s}
  .btn-c:hover{transform:translateY(-3px);box-shadow:0 12px 40px rgba(0,229,255,.35)}.btn-c:hover::before{transform:translateX(100%)}
  .btn-out{padding:.9rem 2.2rem;border-radius:8px;border:1px solid var(--rim);background:var(--card);color:var(--txt);font-size:.88rem;font-weight:500;font-family:var(--B);cursor:pointer;transition:all .3s;backdrop-filter:blur(8px)}
  .btn-out:hover{border-color:rgba(255,255,255,.2);background:rgba(255,255,255,.06);transform:translateY(-3px)}
  .hero-ticker{position:absolute;bottom:0;left:0;right:0;border-top:1px solid var(--rim);background:rgba(3,4,10,.6);backdrop-filter:blur(12px);overflow:hidden;height:44px;z-index:4;display:flex;align-items:center}
  .ticker-track{display:flex;white-space:nowrap;animation:ticker 28s linear infinite}
  .ticker-item{padding:0 2rem;font-size:.72rem;font-weight:600;letter-spacing:.1em;text-transform:uppercase;color:var(--muted);border-right:1px solid var(--rim);flex-shrink:0;display:flex;align-items:center;gap:10px}
  .ticker-dot{width:4px;height:4px;border-radius:50%;background:var(--c)}
  @keyframes ticker{0%{transform:translateX(0)}100%{transform:translateX(-50%)}}

  .sec-ey{display:flex;align-items:center;gap:10px;margin-bottom:1rem}
  .sec-ey-txt{font-size:.7rem;font-weight:700;letter-spacing:.16em;text-transform:uppercase;color:var(--c)}
  .ey-line{height:1px;background:linear-gradient(90deg,var(--c),transparent);width:50px}
  .sec-title{font-family:var(--D);font-size:clamp(2.8rem,5vw,4.5rem);letter-spacing:.04em;color:var(--white);line-height:.95;margin-bottom:1.5rem}
  .sec-p{font-size:.95rem;color:var(--muted);line-height:1.9;font-weight:300}
  .ibox{display:flex;align-items:center;justify-content:center;border-radius:10px;background:rgba(0,229,255,.07);border:1px solid rgba(0,229,255,.12);color:var(--c);flex-shrink:0}

  .about{padding:120px 4%;background:var(--deep);border-top:1px solid var(--rim);position:relative;overflow:hidden}
  .about::before{content:'';position:absolute;top:-200px;right:-200px;width:600px;height:600px;border-radius:50%;background:radial-gradient(circle,rgba(162,89,255,.08),transparent 70%);pointer-events:none}
  .about-grid{display:grid;grid-template-columns:1fr 1fr;gap:5rem;align-items:center;max-width:1200px;margin:0 auto}
  .a-card{background:var(--card);border:1px solid var(--rim);border-radius:20px;padding:2.5rem;position:relative;overflow:hidden}
  .a-card::before{content:'';position:absolute;top:0;left:0;right:0;height:2px;background:linear-gradient(90deg,var(--c),var(--v),var(--g))}
  .big-num{font-family:var(--D);font-size:6rem;line-height:1;background:linear-gradient(120deg,var(--c),var(--v));-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;letter-spacing:.05em}
  .pills{display:flex;flex-wrap:wrap;gap:8px;margin-top:1.5rem}
  .pill{padding:5px 14px;border-radius:100px;border:1px solid rgba(0,229,255,.15);background:rgba(0,229,255,.06);font-size:.72rem;font-weight:600;letter-spacing:.04em;color:var(--c)}
  .feat-row{display:flex;flex-direction:column;gap:1rem;margin-top:2rem}
  .feat-item{display:flex;align-items:center;gap:1rem;padding:1rem 1.25rem;background:var(--card);border:1px solid var(--rim);border-radius:12px;transition:all .3s;cursor:default}
  .feat-item:hover{border-color:rgba(0,229,255,.25);transform:translateX(8px)}
  .feat-title{font-size:.88rem;font-weight:600;color:var(--white)}
  .feat-desc{font-size:.78rem;color:var(--muted);margin-top:2px}

  .services{padding:120px 4%;background:var(--ink)}
  .svc-header{max-width:1200px;margin:0 auto 4rem}
  .svc-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:1.5px;max-width:1200px;margin:0 auto;background:var(--rim);border-radius:20px;overflow:hidden}
  .svc-card{background:var(--ink);padding:2.5rem 2rem;position:relative;transition:background .4s;cursor:default;overflow:hidden}
  .svc-card::after{content:'';position:absolute;bottom:0;left:0;right:0;height:2px;background:linear-gradient(90deg,var(--c),var(--v));transform:scaleX(0);transform-origin:left;transition:transform .4s}
  .svc-card:hover{background:rgba(0,229,255,.03)}.svc-card:hover::after{transform:scaleX(1)}
  .svc-num{font-family:var(--D);font-size:.9rem;color:var(--muted);letter-spacing:.1em;margin-bottom:1.5rem}
  .svc-ibox{width:48px;height:48px;border-radius:12px;background:rgba(0,229,255,.07);border:1px solid rgba(0,229,255,.12);display:flex;align-items:center;justify-content:center;color:var(--c);margin-bottom:1.25rem}
  .svc-title{font-size:1.05rem;font-weight:700;color:var(--white);margin-bottom:.75rem}
  .svc-desc{font-size:.82rem;color:var(--muted);line-height:1.8}

  .projects{padding:120px 4%;background:var(--deep);border-top:1px solid var(--rim)}
  .proj-header{max-width:1200px;margin:0 auto 4rem}
  .proj-grid{display:grid;grid-template-columns:repeat(2,1fr);gap:1.5rem;max-width:1200px;margin:0 auto}
  .proj-card{background:var(--card);border:1px solid var(--rim);border-radius:16px;padding:2rem;position:relative;overflow:hidden;transition:all .4s;cursor:pointer}
  .proj-card.feat{grid-column:1/-1}
  .proj-card:hover{border-color:rgba(162,89,255,.3);box-shadow:0 24px 80px rgba(0,0,0,.5),inset 0 0 0 1px rgba(162,89,255,.1);transform:translateY(-6px)}
  .proj-bg{position:absolute;inset:0;background:linear-gradient(135deg,rgba(162,89,255,.04),transparent);opacity:0;transition:opacity .4s}
  .proj-card:hover .proj-bg{opacity:1}
  .proj-top{display:flex;align-items:flex-start;justify-content:space-between;margin-bottom:1.25rem}
  .proj-badge{font-size:.65rem;font-weight:700;letter-spacing:.12em;text-transform:uppercase;color:var(--v);padding:4px 10px;border-radius:100px;background:rgba(162,89,255,.1);border:1px solid rgba(162,89,255,.2)}
  .proj-arrow{width:32px;height:32px;border-radius:50%;border:1px solid var(--rim);display:flex;align-items:center;justify-content:center;color:var(--muted);flex-shrink:0;transition:all .3s}
  .proj-card:hover .proj-arrow{background:var(--v);border-color:var(--v);color:#fff;transform:rotate(45deg)}
  .proj-name{font-family:var(--D);font-size:2rem;letter-spacing:.05em;color:var(--white);margin-bottom:4px}
  .proj-card.feat .proj-name{font-size:3rem}
  .proj-sub{font-size:.78rem;font-weight:600;color:var(--c);margin-bottom:.75rem;letter-spacing:.03em}
  .proj-desc{font-size:.83rem;color:var(--muted);line-height:1.8;margin-bottom:1.25rem}
  .proj-tags{display:flex;flex-wrap:wrap;gap:6px}
  .tag{padding:3px 10px;border-radius:100px;font-size:.68rem;font-weight:700;letter-spacing:.05em;text-transform:uppercase}
  .tag-ai{background:rgba(0,255,178,.08);color:var(--g);border:1px solid rgba(0,255,178,.15)}
  .tag-hms{background:rgba(0,229,255,.08);color:var(--c);border:1px solid rgba(0,229,255,.15)}
  .tag-erp{background:rgba(162,89,255,.08);color:var(--v);border:1px solid rgba(162,89,255,.15)}
  .tag-crm{background:rgba(255,107,53,.08);color:var(--fire);border:1px solid rgba(255,107,53,.15)}
  .tag-web{background:rgba(255,255,255,.05);color:var(--muted);border:1px solid var(--rim)}
  .feat-strip{display:grid;grid-template-columns:1fr 1fr;gap:1rem;margin-top:1.5rem}
  .feat-stat{background:rgba(0,229,255,.04);border:1px solid rgba(0,229,255,.1);border-radius:10px;padding:1rem;text-align:center}
  .feat-stat-num{font-family:var(--D);font-size:1.8rem;color:var(--g);letter-spacing:.05em}
  .feat-stat-lbl{font-size:.7rem;color:var(--muted);text-transform:uppercase;letter-spacing:.08em}

  .ai-sec{padding:120px 4%;background:var(--ink);overflow:hidden}
  .ai-inner{display:grid;grid-template-columns:1fr 1fr;gap:5rem;align-items:center;max-width:1200px;margin:0 auto}
  .ai-visual{position:relative;height:450px;display:flex;align-items:center;justify-content:center}
  .orb{width:260px;height:260px;border-radius:50%;position:absolute;background:conic-gradient(from 0deg,var(--c),var(--v),var(--g),var(--c));animation:spin 8s linear infinite;-webkit-mask:radial-gradient(circle,transparent 56%,black 57%);mask:radial-gradient(circle,transparent 56%,black 57%);filter:blur(1px)}
  .orb-inner{width:220px;height:220px;border-radius:50%;position:absolute;background:radial-gradient(circle at 35% 35%,rgba(0,229,255,.25),rgba(162,89,255,.15),transparent 70%);border:1px solid rgba(0,229,255,.15)}
  .orb-txt{position:absolute;font-family:var(--D);font-size:1.4rem;letter-spacing:.1em;color:var(--white);text-align:center;line-height:1.1}
  .ring{position:absolute;border:1px solid rgba(0,229,255,.06);border-radius:50%;animation:ringPulse 4s ease-in-out infinite}
  .r1{width:320px;height:320px;animation-delay:0s}.r2{width:400px;height:400px;animation-delay:1.3s}.r3{width:480px;height:480px;animation-delay:2.6s}
  @keyframes spin{100%{transform:rotate(360deg)}}
  @keyframes ringPulse{0%,100%{opacity:.7;transform:scale(1)}50%{opacity:.2;transform:scale(1.03)}}
  .ai-feats{display:flex;flex-direction:column;gap:1.25rem}
  .ai-feat{display:flex;align-items:flex-start;gap:1rem;padding:1.25rem;background:var(--card);border:1px solid var(--rim);border-radius:14px;transition:all .3s;position:relative;overflow:hidden}
  .ai-feat::before{content:'';position:absolute;left:0;top:0;bottom:0;width:2px;background:linear-gradient(to bottom,var(--c),var(--v));transform:scaleY(0);transform-origin:top;transition:transform .3s}
  .ai-feat:hover{border-color:rgba(0,229,255,.2);transform:translateX(6px)}.ai-feat:hover::before{transform:scaleY(1)}
  .ai-feat-title{font-size:.92rem;font-weight:700;color:var(--white);margin-bottom:4px}
  .ai-feat-desc{font-size:.8rem;color:var(--muted);line-height:1.7}

  .why{padding:120px 4%;background:var(--deep);border-top:1px solid var(--rim)}
  .why-hdr{text-align:center;max-width:1200px;margin:0 auto 4rem}
  .why-ey{justify-content:center}
  .why-grid{display:grid;grid-template-columns:repeat(5,1fr);gap:1rem;max-width:1200px;margin:0 auto}
  .why-card{background:var(--card);border:1px solid var(--rim);border-radius:16px;padding:2rem 1.5rem;text-align:center;transition:all .3s;position:relative;overflow:hidden}
  .why-card::before{content:'';position:absolute;inset:0;background:linear-gradient(135deg,rgba(0,229,255,.05),transparent);opacity:0;transition:opacity .3s}
  .why-card:hover{border-color:rgba(0,229,255,.2);transform:translateY(-6px)}.why-card:hover::before{opacity:1}
  .why-ic{display:flex;justify-content:center;margin-bottom:1rem;color:var(--c)}
  .why-big{font-family:var(--D);font-size:2.5rem;letter-spacing:.05em;color:var(--c);line-height:1;margin-bottom:.5rem}
  .why-lbl{font-size:.82rem;font-weight:700;color:var(--white);margin-bottom:.4rem}
  .why-desc{font-size:.73rem;color:var(--muted);line-height:1.6}

  .team{padding:120px 4%;background:var(--ink)}
  .team-hdr{max-width:1200px;margin:0 auto 4rem}
  .team-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:1.5rem;max-width:1200px;margin:0 auto}
  .team-card{background:var(--card);border:1px solid var(--rim);border-radius:20px;padding:2.5rem 1.5rem;text-align:center;transition:all .4s;position:relative;overflow:hidden}
  .team-card::before{content:'';position:absolute;top:0;left:0;right:0;height:2px;background:linear-gradient(90deg,var(--c),var(--v));transform:scaleX(0);transition:transform .4s}
  .team-card:hover{border-color:rgba(162,89,255,.3);transform:translateY(-8px);box-shadow:0 20px 60px rgba(0,0,0,.5)}.team-card:hover::before{transform:scaleX(1)}
  .av-wrap{position:relative;width:80px;height:80px;margin:0 auto 1.25rem}
  .av-ring{position:absolute;inset:-3px;border-radius:50%;background:conic-gradient(var(--c),var(--v),var(--g),var(--c));animation:spin 6s linear infinite}
  .av-inner{position:absolute;inset:2px;border-radius:50%;background:linear-gradient(135deg,var(--deep),var(--ink));display:flex;align-items:center;justify-content:center;font-family:var(--D);font-size:1.8rem;color:var(--c);letter-spacing:.05em;z-index:1}
  .team-name{font-family:var(--D);font-size:1.3rem;letter-spacing:.05em;color:var(--white);margin-bottom:4px}
  .team-role{font-size:.73rem;font-weight:600;color:var(--c);letter-spacing:.08em;text-transform:uppercase;margin-bottom:.75rem}
  .team-bio{font-size:.78rem;color:var(--muted);line-height:1.7}

  .testi{padding:120px 4%;background:var(--deep);border-top:1px solid var(--rim)}
  .testi-hdr{text-align:center;max-width:1200px;margin:0 auto 4rem}
  .testi-ey{justify-content:center}
  .testi-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:1.5rem;max-width:1200px;margin:0 auto}
  .testi-card{background:var(--card);border:1px solid var(--rim);border-radius:20px;padding:2.5rem;position:relative;overflow:hidden;transition:all .3s}
  .testi-card:hover{border-color:rgba(0,229,255,.2);transform:translateY(-4px)}
  .t-quote{color:var(--c);opacity:.15;margin-bottom:.75rem}
  .stars{color:#ffd700;font-size:.9rem;margin-bottom:1rem;letter-spacing:2px}
  .testi-txt{font-size:.88rem;color:var(--txt);line-height:1.9;font-style:italic;font-weight:300;margin-bottom:1.5rem}
  .testi-author{display:flex;align-items:center;gap:12px}
  .testi-av{width:44px;height:44px;border-radius:50%;flex-shrink:0;background:linear-gradient(135deg,var(--c),var(--v));display:flex;align-items:center;justify-content:center;font-family:var(--D);font-size:1.2rem;color:#000}
  .testi-name{font-size:.88rem;font-weight:700;color:var(--white)}
  .testi-co{font-size:.72rem;color:var(--muted)}

  .contact{padding:120px 4%;background:var(--ink);position:relative;overflow:hidden}
  .contact::before{content:'';position:absolute;bottom:-300px;left:50%;transform:translateX(-50%);width:800px;height:800px;border-radius:50%;background:radial-gradient(circle,rgba(0,229,255,.06),transparent 60%);pointer-events:none}
  .contact-inner{display:grid;grid-template-columns:1fr 1fr;gap:5rem;align-items:start;max-width:1100px;margin:0 auto;position:relative;z-index:1}
  .contact-items{display:flex;flex-direction:column;gap:1rem;margin-top:2.5rem}
  .ci{display:flex;align-items:center;gap:1rem;padding:1rem 1.25rem;background:var(--card);border:1px solid var(--rim);border-radius:12px;transition:all .3s}
  .ci:hover{border-color:rgba(0,229,255,.2);transform:translateX(6px)}
  .ci-ic{width:40px;height:40px;border-radius:8px;background:rgba(0,229,255,.08);border:1px solid rgba(0,229,255,.12);display:flex;align-items:center;justify-content:center;color:var(--c);flex-shrink:0}
  .ci-lbl{font-size:.68rem;font-weight:700;letter-spacing:.1em;text-transform:uppercase;color:var(--muted)}
  .ci-val{font-size:.88rem;font-weight:600;color:var(--white);margin-top:2px}
  .c-form{background:var(--card);border:1px solid var(--rim);border-radius:20px;padding:2.5rem;backdrop-filter:blur(20px);position:relative;overflow:hidden}
  .c-form::before{content:'';position:absolute;top:0;left:0;right:0;height:2px;background:linear-gradient(90deg,var(--c),var(--v),var(--g))}
  .f-lbl{display:block;font-size:.72rem;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:var(--muted);margin-bottom:8px}
  .f-in,.f-ta{width:100%;background:rgba(255,255,255,.04);border:1px solid var(--rim);border-radius:8px;padding:.88rem 1rem;color:var(--txt);font-family:var(--B);font-size:.9rem;outline:none;resize:none;transition:all .3s;margin-bottom:1.2rem;display:block}
  .f-in:focus,.f-ta:focus{border-color:var(--c);background:rgba(0,229,255,.04);box-shadow:0 0 0 3px rgba(0,229,255,.08)}
  .f-in::placeholder,.f-ta::placeholder{color:rgba(99,104,130,.6)}
  .f-btn{width:100%;padding:1rem;border:none;border-radius:10px;background:linear-gradient(135deg,var(--c),var(--v));color:#000;font-weight:800;font-family:var(--D);font-size:1.1rem;cursor:pointer;transition:all .3s;text-transform:uppercase;letter-spacing:.1em}
  .f-btn:hover{transform:translateY(-3px);box-shadow:0 12px 40px rgba(0,229,255,.25)}
  .sent-wrap{text-align:center;padding:3rem 1rem}
  .sent-ic{color:var(--g);margin-bottom:1rem;display:flex;justify-content:center}
  .sent-title{font-family:var(--D);font-size:1.8rem;color:var(--g);letter-spacing:.08em;margin-bottom:.5rem}
  .sent-sub{color:var(--muted);font-size:.88rem}

  footer{background:var(--deep);border-top:1px solid var(--rim);padding:3rem 4%}
  .foot-in{max-width:1200px;margin:0 auto;display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:2rem}
  .foot-tag{font-size:.75rem;color:var(--muted);margin-top:6px;letter-spacing:.04em}
  .foot-links{display:flex;gap:2rem}
  .foot-links a{color:var(--muted);text-decoration:none;font-size:.8rem;font-weight:500;transition:color .2s}
  .foot-links a:hover{color:var(--white)}
  .socials{display:flex;gap:.75rem}
  .soc{width:38px;height:38px;border-radius:8px;background:var(--card);border:1px solid var(--rim);display:flex;align-items:center;justify-content:center;color:var(--muted);text-decoration:none;transition:all .3s}
  .soc:hover{border-color:var(--c);color:var(--c);background:rgba(0,229,255,.08)}
  .copy{width:100%;text-align:center;font-size:.72rem;color:var(--muted);padding-top:2rem;border-top:1px solid var(--rim);margin-top:1rem}

  @keyframes fadeUp{from{opacity:0;transform:translateY(28px)}to{opacity:1;transform:translateY(0)}}
  .reveal{opacity:0;transform:translateY(32px);transition:opacity .7s ease,transform .7s ease}
  .reveal.vis{opacity:1;transform:translateY(0)}

  @media(max-width:1024px){.about-grid,.ai-inner,.contact-inner{grid-template-columns:1fr;gap:3rem}.svc-grid{grid-template-columns:repeat(2,1fr)}.proj-grid{grid-template-columns:1fr}.proj-card.feat{grid-column:auto}.why-grid{grid-template-columns:repeat(3,1fr)}.team-grid{grid-template-columns:repeat(2,1fr)}.testi-grid{grid-template-columns:repeat(2,1fr)}}
  @media(max-width:768px){.nav-links{display:none}.svc-grid{grid-template-columns:1fr}.why-grid{grid-template-columns:repeat(2,1fr)}.team-grid{grid-template-columns:1fr 1fr}.testi-grid{grid-template-columns:1fr}.feat-strip{grid-template-columns:1fr 1fr}.ai-visual{height:280px}}
  @media(max-width:480px){.why-grid{grid-template-columns:1fr 1fr}.team-grid{grid-template-columns:1fr}.foot-in{flex-direction:column;align-items:flex-start}}
`;

/* cursor */
function Cursor() {
  const dot=useRef(null), ring=useRef(null);
  useEffect(()=>{
    const mv=(e)=>{ if(dot.current){dot.current.style.left=e.clientX+"px";dot.current.style.top=e.clientY+"px";} if(ring.current){ring.current.style.left=e.clientX+"px";ring.current.style.top=e.clientY+"px";} };
    window.addEventListener("mousemove",mv);
    return()=>window.removeEventListener("mousemove",mv);
  },[]);
  return(<><div className="cur-dot" ref={dot}/><div className="cur-ring" ref={ring}/></>);
}

/* canvas */
function HeroCanvas() {
  const ref=useRef(null);
  useEffect(()=>{
    const cvs=ref.current,ctx=cvs.getContext("2d");
    let w,h,nodes=[],raf;
    const N=55,D=140;
    const init=()=>{ w=cvs.width=cvs.offsetWidth;h=cvs.height=cvs.offsetHeight;nodes=Array.from({length:N},()=>({x:Math.random()*w,y:Math.random()*h,vx:(Math.random()-.5)*.5,vy:(Math.random()-.5)*.5,r:Math.random()*2+.5})); };
    const draw=()=>{
      ctx.clearRect(0,0,w,h);
      for(let i=0;i<N;i++){
        const a=nodes[i];a.x+=a.vx;a.y+=a.vy;
        if(a.x<0||a.x>w)a.vx*=-1;if(a.y<0||a.y>h)a.vy*=-1;
        for(let j=i+1;j<N;j++){const b=nodes[j],dx=a.x-b.x,dy=a.y-b.y,d=Math.sqrt(dx*dx+dy*dy);if(d<D){const al=(1-d/D)*.35,g=ctx.createLinearGradient(a.x,a.y,b.x,b.y);g.addColorStop(0,`rgba(0,229,255,${al})`);g.addColorStop(1,`rgba(162,89,255,${al})`);ctx.strokeStyle=g;ctx.lineWidth=.6;ctx.beginPath();ctx.moveTo(a.x,a.y);ctx.lineTo(b.x,b.y);ctx.stroke();}}
        ctx.beginPath();ctx.arc(a.x,a.y,a.r,0,Math.PI*2);ctx.fillStyle="rgba(0,229,255,.5)";ctx.fill();
      }
      raf=requestAnimationFrame(draw);
    };
    init();draw();
    const ro=new ResizeObserver(init);ro.observe(cvs);
    return()=>{cancelAnimationFrame(raf);ro.disconnect();};
  },[]);
  return <canvas ref={ref} className="hero-canvas" style={{position:"absolute",inset:0,width:"100%",height:"100%"}}/>;
}

/* reveal */
function useReveal(){
  useEffect(()=>{
    const els=document.querySelectorAll(".reveal");
    const io=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add("vis");io.unobserve(e.target);}}),{threshold:.1});
    els.forEach(el=>io.observe(el));
    return()=>io.disconnect();
  },[]);
}

/* nav */
function Nav(){
  const [g,setG]=useState(false);
  useEffect(()=>{const s=()=>setG(window.scrollY>40);window.addEventListener("scroll",s);return()=>window.removeEventListener("scroll",s);},[]);
  const go=(id)=>document.getElementById(id)?.scrollIntoView({behavior:"smooth"});
  return(
    <nav className={`nav${g?" glass":""}`}>
      <a href="#hero" className="logo">Hypervolar</a>
      <ul className="nav-links">
        {["about","services","projects","innovation","contact"].map(id=>(
          <li key={id}><a href={`#${id}`} onClick={e=>{e.preventDefault();go(id);}}>{id[0].toUpperCase()+id.slice(1)}</a></li>
        ))}
      </ul>
      <button className="nav-btn" onClick={()=>go("contact")}>Let's Talk →</button>
    </nav>
  );
}

/* ticker */
const TICKS=["Custom Software","Healthcare Systems","AI Vision","ERP Automation","Node.js · React","Power BI","ML Pipelines","5+ Years","20+ Projects","10+ Clients"];
function Ticker(){
  const items=[...TICKS,...TICKS];
  return(<div className="hero-ticker"><div className="ticker-track">{items.map((t,i)=><div className="ticker-item" key={i}><span className="ticker-dot"/>{t}</div>)}</div></div>);
}

/* hero */
function Hero(){
  const go=(id)=>document.getElementById(id)?.scrollIntoView({behavior:"smooth"});
  return(
    <section id="hero" className="hero">
      <div className="hero-mesh"/><HeroCanvas/>
      <div className="hero-z">
        <div className="eyebrow"><span className="blink"/>Engineering · 5+ Years · Real-World Impact</div>
        <h1 className="hero-h1">TURNING YOUR<br/>VISION INTO<br/><span className="accent">REALITY</span></h1>
        <p className="hero-p">5+ Years Engineering Smart Solutions Across Healthcare, ERP, AI &amp; Automation. We transform complex challenges into scalable systems that move businesses forward.</p>
        <div className="hero-btns">
          <button className="btn-c" onClick={()=>go("projects")}>View Our Work</button>
          <button className="btn-out" onClick={()=>go("contact")}>Contact Us →</button>
        </div>
      </div>
      <Ticker/>
    </section>
  );
}

/* about */
const AFEATS=[
  {Icon:IC.Pulse,  t:"Scalable Architecture", d:"Built for the next 5 years, not just the next sprint."},
  {Icon:IC.CPU,    t:"AI-First Engineering",   d:"Intelligence baked into every layer — not bolted on after."},
  {Icon:IC.Shield, t:"Long-Term Partnership",  d:"We don't ship and disappear. We stay and grow with you."},
];
function About(){
  return(
    <section id="about" className="about">
      <div className="about-grid">
        <div className="reveal">
          <div className="a-card">
            <div className="big-num">5+<br/><span style={{fontSize:"2.5rem",letterSpacing:".02em"}}>YEARS</span></div>
            <p className="sec-p" style={{marginTop:"1rem"}}>A team of expert engineers, AI specialists, and system architects who thrive where complexity is highest. 5+ years building production-grade software across healthcare, enterprise, logistics, and AI.</p>
            <div className="pills">{["Node.js","React","Python","AI / ML","Computer Vision","Power BI","Automation","PostgreSQL","Oracle","Laravel","Docker"].map(t=><span className="pill" key={t}>{t}</span>)}</div>
          </div>
        </div>
        <div className="reveal">
          <div className="sec-ey"><span className="sec-ey-txt">Our Story</span><div className="ey-line"/></div>
          <h2 className="sec-title">BUILT TO SOLVE.<br/>MADE TO SCALE.</h2>
          <p className="sec-p">We started with a single belief: every complex problem has an elegant engineering solution. Across healthcare, enterprise, logistics, and AI — we've proven it again and again.</p>
          <div className="feat-row">
            {AFEATS.map(f=>(
              <div className="feat-item" key={f.t}>
                <div className="ibox" style={{width:36,height:36}}><f.Icon/></div>
                <div><div className="feat-title">{f.t}</div><div className="feat-desc">{f.d}</div></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

/* services */
const SVCS=[
  {n:"01",Icon:IC.Code,   t:"Custom Software Development", d:"Tailor-made platforms engineered for your exact business logic. Clean architecture, scalable codebases, zero shortcuts."},
  {n:"02",Icon:IC.Health, t:"Healthcare Systems",          d:"HMS, IVF clinic management, CRM platforms — purpose-built for high-stakes healthcare workflows and regulatory requirements."},
  {n:"03",Icon:IC.Grid,   t:"ERP & Business Automation",   d:"Unified ERP systems connecting procurement, inventory, finance, and HR — eliminating silos and manual overhead entirely."},
  {n:"04",Icon:IC.Brain,  t:"AI / ML & Vision Systems",    d:"Custom models, computer vision pipelines, and ML-powered automation. We built a live yard-tracking AI for CONCOR."},
  {n:"05",Icon:IC.Chart,  t:"Dashboard & Analytics",       d:"Power BI dashboards and custom reporting pipelines that surface real insights from complex operational data."},
  {n:"06",Icon:IC.Globe,  t:"Web Development & Support",   d:"High-performance web applications with long-term technical support. We evolve your digital presence as you grow."},
];
function Services(){
  return(
    <section id="services" className="services">
      <div className="svc-header reveal">
        <div className="sec-ey"><span className="sec-ey-txt">What We Do</span><div className="ey-line"/></div>
        <h2 className="sec-title">END-TO-END<br/>ENGINEERING</h2>
        <p className="sec-p" style={{marginTop:"1rem"}}>From idea to production across every domain — we handle the full lifecycle of complex software.</p>
      </div>
      <div className="svc-grid">
        {SVCS.map((s,i)=>(
          <div className="svc-card reveal" key={s.t} style={{transitionDelay:`${i*60}ms`}}>
            <div className="svc-num">{s.n}</div>
            <div className="svc-ibox"><s.Icon/></div>
            <div className="svc-title">{s.t}</div>
            <p className="svc-desc">{s.d}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

/* projects */
const PROJS=[
  {id:"01",cat:"HEALTHCARE",      Icon:IC.IVF, logo:"/logos/aveya.png",       name:"AVEYA IVF",    sub:"IVF Clinic Management System",        desc:"End-to-end IVF workflow covering patient intake, cycle tracking, embryology lab, billing, and reporting — purpose-built for fertility clinics.",                       tags:[{l:"HMS",c:"hms"},{l:"CRM",c:"crm"},{l:"Web App",c:"web"}],ac:"rgba(0,229,255,.025)",ab:"rgba(0,229,255,.12)"},
  {id:"02",cat:"HEALTHCARE",      Icon:IC.HMS, logo:"/logos/lifelinkr.png",   name:"LIFELINKR",    sub:"Hospital Management System",           desc:"Comprehensive multi-department HMS covering OPD, IPD, pharmacy, lab, radiology, and finance — unified in a single intelligent platform.",                           tags:[{l:"HMS",c:"hms"},{l:"Automation",c:"ai"},{l:"Web App",c:"web"}],ac:"rgba(0,255,178,.02)",ab:"rgba(0,255,178,.12)"},
  {id:"03",cat:"HR & MANAGEMENT", Icon:IC.HR,  logo:"/logos/traveme.png",     name:"TRAVEME",      sub:"HR & Employee Management System",      desc:"Full-cycle HR platform — attendance, payroll, leave management, performance tracking, and hiring pipeline for growing organisations.",                              tags:[{l:"ERP",c:"erp"},{l:"Automation",c:"ai"},{l:"Web App",c:"web"}],ac:"rgba(162,89,255,.02)",ab:"rgba(162,89,255,.12)"},
  {id:"04",cat:"ENTERPRISE",      Icon:IC.ERP, logo:"/logos/ananta.png",      name:"ANANTA GROUP", sub:"Enterprise Resource Planning",         desc:"Custom group-level ERP managing procurement, manufacturing, distribution, and finance across multiple business units.",                                              tags:[{l:"ERP",c:"erp"},{l:"Enterprise",c:"crm"}],ac:"rgba(255,107,53,.02)",ab:"rgba(255,107,53,.12)"},
  {id:"05",cat:"HEALTHCARE + WEB",Icon:IC.Web, logo:"/logos/scihospital.png", name:"SCIHOSPITAL",  sub:"Website & Technical Support",          desc:"Professional website development and long-term technical support — covering design, performance, SEO, and continuity.",                                              tags:[{l:"Web",c:"web"},{l:"Healthcare",c:"hms"}],ac:"rgba(0,229,255,.02)",ab:"rgba(0,229,255,.1)"},
  {id:"06",cat:"CRM",             Icon:IC.CRM, logo:"/logos/vatsalya.png",    name:"VATSALYA",     sub:"CRM & Client Management System",       desc:"Smart CRM with lead tracking, customer lifecycle, follow-up automation, and reporting dashboards for healthcare and service sectors.",                               tags:[{l:"CRM",c:"crm"},{l:"Automation",c:"ai"}],ac:"rgba(255,107,53,.02)",ab:"rgba(255,107,53,.1)"},
];

function Logo({path,name,FallIcon}){
  const [err,setErr]=useState(false);
  if(!err) return <img src={path} alt={name} onError={()=>setErr(true)} style={{height:36,maxWidth:130,objectFit:"contain",filter:"brightness(0) invert(1)",opacity:.85}}/>;
  return(
    <div style={{display:"flex",alignItems:"center",gap:9}}>
      <div style={{width:34,height:34,borderRadius:8,background:"rgba(255,255,255,.06)",border:"1px solid rgba(255,255,255,.1)",display:"flex",alignItems:"center",justifyContent:"center",color:"var(--c)",flexShrink:0}}><FallIcon/></div>
      <span style={{fontFamily:"var(--D)",fontSize:"1rem",letterSpacing:".06em",color:"var(--white)",lineHeight:1}}>{name}</span>
    </div>
  );
}

function Projects(){
  return(
    <section id="projects" className="projects">
      <div className="proj-header reveal">
        <div className="sec-ey"><span className="sec-ey-txt">Our Work</span><div className="ey-line"/></div>
        <h2 className="sec-title">WORK THAT<br/>SPEAKS FOR ITSELF.</h2>
        <p className="sec-p" style={{marginTop:"1rem"}}>A track record of complex systems delivered across industries — running at scale, every day.</p>
      </div>
      <div className="proj-grid">
        {/* CONCOR flagship */}
        <div className="proj-card feat reveal" style={{background:"rgba(0,229,255,.025)",borderColor:"rgba(0,229,255,.14)"}}>
          <div className="proj-bg"/>
          <div className="proj-top">
            <span className="proj-badge" style={{background:"rgba(0,255,178,.1)",color:"var(--g)",borderColor:"rgba(0,255,178,.2)"}}>07 — AI VISION · FLAGSHIP</span>
            <span className="proj-arrow"><IC.Arrow/></span>
          </div>
          <div style={{marginBottom:"1.5rem"}}><Logo path="/logos/concor.png" name="CONCOR" FallIcon={IC.AI}/></div>
          <div className="proj-sub">AI-Based Yard Automation — Vision System</div>
          <p className="proj-desc" style={{maxWidth:700}}>Real-time computer vision platform for autonomous container and vehicle tracking at one of India's largest container logistics companies. Integrates live camera feeds, OCR, and custom ML models — eliminating manual tracking and enabling fully data-driven yard operations.</p>
          <div className="feat-strip">
            {[["90%","Error Reduction"],["Real-Time","Live Tracking"],["Custom ML","Models Built"],["Autonomous","Yard Ops"]].map(([n,l])=>(
              <div className="feat-stat" key={l}><div className="feat-stat-num">{n}</div><div className="feat-stat-lbl">{l}</div></div>
            ))}
          </div>
          <div className="proj-tags" style={{marginTop:"1.5rem"}}>
            {[{l:"AI",c:"ai"},{l:"Vision",c:"ai"},{l:"Automation",c:"ai"},{l:"Logistics",c:"erp"},{l:"ML",c:"ai"}].map((t,i)=><span className={`tag tag-${t.c}`} key={i}>{t.l}</span>)}
          </div>
        </div>
        {/* regular cards */}
        {PROJS.map((p,i)=>(
          <div className="proj-card reveal" key={p.name} style={{transitionDelay:`${i*70}ms`,background:p.ac,borderColor:p.ab}}>
            <div className="proj-bg"/>
            <div className="proj-top">
              <span className="proj-badge">{p.id} — {p.cat}</span>
              <span className="proj-arrow"><IC.Arrow/></span>
            </div>
            <div style={{marginBottom:"1.25rem",minHeight:36,display:"flex",alignItems:"center"}}><Logo path={p.logo} name={p.name} FallIcon={p.Icon}/></div>
            <div className="proj-sub">{p.sub}</div>
            <p className="proj-desc">{p.desc}</p>
            <div className="proj-tags">{p.tags.map((t,j)=><span className={`tag tag-${t.c}`} key={j}>{t.l}</span>)}</div>
          </div>
        ))}
      </div>
    </section>
  );
}

/* innovation */
const AIFEATS=[
  {Icon:IC.Eye,     t:"Vision AI for Yard & Container Tracking",  d:"Live camera-based recognition and tracking of containers, vehicles, and assets in industrial environments. Deployed at CONCOR."},
  {Icon:IC.Zap,     t:"Intelligent Process Automation",           d:"ML-driven workflows eliminating manual bottlenecks — from document processing to predictive logistics routing."},
  {Icon:IC.Monitor, t:"Real-Time Monitoring Systems",             d:"Live dashboards and alert systems that surface critical events the moment they happen across operations and healthcare."},
  {Icon:IC.Brain,   t:"Custom ML Model Development",              d:"Purpose-built models trained on your domain data — classification, object detection, NLP, and predictive analytics."},
];
function Innovation(){
  return(
    <section id="innovation" className="ai-sec">
      <div className="ai-inner">
        <div className="ai-visual reveal">
          <div className="ring r1"/><div className="ring r2"/><div className="ring r3"/>
          <div className="orb"/><div className="orb-inner"/>
          <div className="orb-txt">VISION<br/>AI</div>
        </div>
        <div className="reveal">
          <div className="sec-ey"><span className="sec-ey-txt">AI & Innovation</span><div className="ey-line"/></div>
          <h2 className="sec-title">INTELLIGENCE<br/>BUILT IN.</h2>
          <p className="sec-p" style={{marginTop:".75rem",marginBottom:"2rem"}}>We don't bolt AI on as an afterthought. We architect intelligent systems from the ground up — with computer vision, ML pipelines, and real-time automation at the core.</p>
          <div className="ai-feats">
            {AIFEATS.map(f=>(
              <div className="ai-feat" key={f.t}>
                <div className="ibox" style={{width:42,height:42}}><f.Icon/></div>
                <div><div className="ai-feat-title">{f.t}</div><div className="ai-feat-desc">{f.d}</div></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

/* why */
const WHY=[
  {Icon:IC.Award,    n:"5+",   l:"Years Experience",      d:"Proven across healthcare, enterprise, logistics, and AI."},
  {Icon:IC.Layers,   n:"20+",  l:"Systems Delivered",     d:"Production systems running at real companies, at scale."},
  {Icon:IC.Sparkle,  n:"AI",   l:"First Mindset",         d:"Intelligence evaluated and integrated in every engagement."},
  {Icon:IC.Infinite, n:"∞",    l:"Scalable Architecture", d:"We build for the next 5 years — no technical debt."},
  {Icon:IC.Users,    n:"24/7", l:"Reliable Support",      d:"Long-term partnership, not one-time delivery."},
];
function Why(){
  return(
    <section id="why" className="why">
      <div className="why-hdr reveal">
        <div className="sec-ey why-ey"><span className="sec-ey-txt">Why Us</span></div>
        <h2 className="sec-title">WHY TEAMS TRUST US</h2>
        <p className="sec-p" style={{margin:"0 auto"}}>We bring more than code — commitment, expertise, and a problem-solving DNA that runs through everything we build.</p>
      </div>
      <div className="why-grid">
        {WHY.map((w,i)=>(
          <div className="why-card reveal" key={w.l} style={{transitionDelay:`${i*80}ms`}}>
            <div className="why-ic"><w.Icon/></div>
            <div className="why-big">{w.n}</div>
            <div className="why-lbl">{w.l}</div>
            <div className="why-desc">{w.d}</div>
          </div>
        ))}
      </div>
    </section>
  );
}

/* team */
// const TEAM = [
//   {
//     init: "S",
//     name: "Sahil Gupta",
//     role: "Founder & Engineer",
//     bio: "Full-stack developer specializing in scalable systems, AI integrations, and enterprise applications. Leading product development and technical strategy."
//   },
//   {
//     init: "B",
//     name: "Bharat Singh",
//     role: "Backend Architect",
//     bio: "Expert in backend architecture, database design, and high-performance APIs. Designs robust and scalable server-side systems."
//   },
//   {
//     init: "L",
//     name: "Lakshay Chaudhary",
//     role: "Full Stack Developer",
//     bio: "Works across frontend and backend to build seamless, high-performance applications with clean and efficient code."
//   },
//   {
//     init: "K",
//     name: "Kamakhya Narayan",
//     role: "Frontend Engineer",
//     bio: "Specialist in building intuitive, responsive, and visually appealing user interfaces using modern frontend technologies."
//   }
// ];
// function Team(){
//   return(
//     <section id="team" className="team">
//       <div className="team-hdr reveal">
//         <div className="sec-ey"><span className="sec-ey-txt">The Team</span><div className="ey-line"/></div>
//         <h2 className="sec-title">BUILDERS.<br/>THINKERS.<br/>SOLVERS.</h2>
//         <p className="sec-p" style={{marginTop:"1rem"}}>A small team with outsized impact — every person a specialist with a passion for hard problems.</p>
//       </div>
//       <div className="team-grid">
//         {TEAM.map((m,i)=>(
//           <div className="team-card reveal" key={m.name} style={{transitionDelay:`${i*80}ms`}}>
//             <div className="av-wrap"><div className="av-ring"/><div className="av-inner">{m.init}</div></div>
//             <div className="team-name">{m.name.toUpperCase()}</div>
//             <div className="team-role">{m.role}</div>
//             <p className="team-bio">{m.bio}</p>
//           </div>
//         ))}
//       </div>
//     </section>
//   );
// }

/* testimonials */
const TESTIS = [
  {
    av: "A",
    name: "Ajay Pandey",
    co: "Team, TravMe",
    text: "Hypervolar built a complete HR and management system for us that streamlined operations and improved team productivity. Their understanding of real business needs is impressive."
  },
  {
    av: "S",
    name: "Sukhwant Gandhi",
    co: "Director, Aveya IVF",
    text: "The IVF management system developed by Hypervolar transformed our clinic operations. From patient tracking to reporting, everything is now efficient and reliable."
  },
  {
    av: "B",
    name: "Bharat Singh",
    co: "Founder, 360Plot",
    text: "Their ability to understand complex requirements and convert them into scalable software is outstanding. The platform they delivered is fast, reliable, and future-ready."
  },
  {
    av: "V",
    name: "Vatsalya Team",
    co: "CRM Platform",
    text: "The CRM system built by Hypervolar helped us manage leads, follow-ups, and customer relationships efficiently. It significantly improved our workflow and tracking."
  },
  {
    av: "S",
    name: "SCI Hospital Team",
    co: "Healthcare Platform",
    text: "Hypervolar provided excellent website and technical support services. Their team ensured smooth performance, reliability, and long-term stability for our digital presence."
  }
];
function Testimonials(){
  return(
    <section className="testi">
      <div className="testi-hdr reveal">
        <div className="sec-ey testi-ey"><span className="sec-ey-txt">Client Voices</span></div>
        <h2 className="sec-title">WHAT CLIENTS SAY</h2>
        <p className="sec-p" style={{margin:"1rem auto 0"}}>Don't take our word for it. Here's what the people we've built for have to say.</p>
      </div>
      <div className="testi-grid">
        {TESTIS.map((t,i)=>(
          <div className="testi-card reveal" key={t.name} style={{transitionDelay:`${i*100}ms`}}>
            <div className="t-quote"><IC.Quote/></div>
            <div className="stars">★★★★★</div>
            <p className="testi-txt">"{t.text}"</p>
            <div className="testi-author">
              <div className="testi-av">{t.av}</div>
              <div>
                <div className="testi-name">{t.name}</div>
                <div className="testi-co">{t.co}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

/* contact */
  const CITEMS = [
  { Icon: IC.Mail, l: "Email", v: "hypervolar@gmail.com", link: "mailto:hypervolar@gmail.com" },
  { Icon: IC.Phone, l: "Phone", v: "+91 78274 36219", link: "tel:+917827436219" },
  { Icon: IC.MapPin, l: "Location", v: "India · Remote-First" },
];
function Contact(){
  const [form, setForm] = useState({
  name: "",
  email: "",
  message: ""
});

const [sent, setSent] = useState(false);
const [loading, setLoading] = useState(false);
const handleChange = (e) => {
  setForm({
    ...form,
    [e.target.name]: e.target.value
  });
};
const handleSend = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    const res = await fetch("https://sahilkkc01.app.n8n.cloud/webhook-test/e744f1c7-e4ca-400f-bd6a-05da19147f0a", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(form)
    });

    const data = await res.json();

    if (res.ok) {
      setSent(true);
      setForm({ name: "", email: "", message: "" });
    } else {
      alert(data.message || "Something went wrong");
    }
  } catch (err) {
    console.error(err);
    alert("Server error");
  }

  setLoading(false);
};
  return(
    <section id="contact" className="contact">
      <div className="contact-inner">
        <div className="reveal">
          <div className="sec-ey"><span className="sec-ey-txt">Get In Touch</span><div className="ey-line"/></div>
          <h2 className="sec-title">LET'S BUILD<br/>TOGETHER</h2>
          <p className="sec-p" style={{marginTop:"1rem"}}>Have a complex challenge, a system to build, or just an idea? Every great solution starts with a conversation.</p>

<div className="contact-items">
  {CITEMS.map((c) => (
    <div className="ci" key={c.l}>
      <div className="ci-ic"><c.Icon /></div>
      <div>
        <div className="ci-lbl">{c.l}</div>
        <div className="ci-val">
          {c.link ? (
            <a href={c.link}>{c.v}</a>
          ) : (
            c.v
          )}
        </div>
      </div>
    </div>
  ))}
</div>
        </div>
        <div className="c-form reveal">
          {!sent?(
            <>
              <div style={{fontFamily:"var(--D)",fontSize:"1.6rem",color:"var(--white)",letterSpacing:".04em",marginBottom:".5rem"}}>START A CONVERSATION</div>
              <p style={{fontSize:".82rem",color:"var(--muted)",marginBottom:"1.75rem"}}>Tell us about your project. We respond within 24 hours.</p>
             <form onSubmit={handleSend}>
  <label className="f-lbl">Name</label>
  <input
    className="f-in"
    name="name"
    value={form.name}
    onChange={handleChange}
    placeholder="Your name"
    required
  />

  <label className="f-lbl">Email</label>
  <input
    className="f-in"
    name="email"
    value={form.email}
    onChange={handleChange}
    placeholder="Your email"
    required
  />

  <label className="f-lbl">Message</label>
  <textarea
    className="f-ta"
    name="message"
    value={form.message}
    onChange={handleChange}
    placeholder="Your message"
    required
  />

  <button className="f-btn" type="submit">
    {loading ? "Sending..." : "Send Message"}
  </button>
</form>
            </>
          ):(
            <div className="sent-wrap">
              <div className="sent-ic"><IC.Check/></div>
              <div className="sent-title">MESSAGE SENT!</div>
              <p className="sent-sub">We'll be in touch within 24 hours.</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

/* footer */
function Footer(){
  const go=(id)=>document.getElementById(id)?.scrollIntoView({behavior:"smooth"});
  return(
    <footer>
      <div className="foot-in">
        <div>
          <div style={{fontFamily:"var(--D)",fontSize:"1.8rem",letterSpacing:".08em",background:"linear-gradient(120deg,#fff 40%,var(--c))",WebkitBackgroundClip:"text",WebkitTextFillColor:"transparent",backgroundClip:"text"}}>Hypervolar</div>
          <div className="foot-tag">Engineering Solutions That Matter</div>
        </div>
        <div className="foot-links">
          {["about","services","projects","innovation","contact"].map(id=>(
            <a href={`#${id}`} key={id} onClick={e=>{e.preventDefault();go(id);}}>{id[0].toUpperCase()+id.slice(1)}</a>
          ))}
        </div>
        <div className="socials">
          {/* <a href="#" className="soc" title="LinkedIn"><IC.LinkedIn/></a>
          <a href="#" className="soc" title="Twitter"><IC.Twitter/></a>
          <a href="#" className="soc" title="GitHub"><IC.Github/></a> */}
        </div>
        <div className="copy">
  © {new Date().getFullYear()} Hypervolar · All rights reserved · Crafted with precision, engineered with purpose.
</div>
      </div>
    </footer>
  );
}

/* root */
export default function Hypervolar(){
  useReveal();
  return(
    <>
      <style>{CSS}</style>
      <FontLink/>
      <Cursor/>
      <Nav/>
      <Hero/>
      <About/>
      <Services/>
      <Projects/>
      <Innovation/>
      <Why/>
      {/* <Team/> */}
      <Testimonials/>
      <Contact/>
      <Footer/>
    </>
  );
}